import { Controller } from "@hotwired/stimulus"
import { api, apiErrorMessage } from "../composables/useApi"

export default class extends Controller {
  static values = { membershipId: Number }
  static targets = ["acceptBtn", "declineBtn", "status"]

  accept() {
    this.acceptBtnTarget.disabled = true
    this.declineBtnTarget.disabled = true
    this.statusTarget.textContent = ""

    api.patch(`/group_memberships/${this.membershipIdValue}/accept`)
      .then(() => {
        this.element.outerHTML = `
          <span class="group-membership-badge group-membership-badge--member">
            <i class="fas fa-check-circle"></i> Member
          </span>
        `
      })
      .catch(error => {
        this.acceptBtnTarget.disabled = false
        this.declineBtnTarget.disabled = false
        this.statusTarget.textContent = apiErrorMessage(error, "Could not accept invitation")
      })
  }

  decline() {
    this.acceptBtnTarget.disabled = true
    this.declineBtnTarget.disabled = true
    this.statusTarget.textContent = ""

    api.patch(`/group_memberships/${this.membershipIdValue}/reject`)
      .then(() => {
        this.element.outerHTML = `
          <span class="group-membership-badge group-membership-badge--invite-only">
            <i class="fas fa-lock"></i> Invite Only
          </span>
        `
      })
      .catch(error => {
        this.acceptBtnTarget.disabled = false
        this.declineBtnTarget.disabled = false
        this.statusTarget.textContent = apiErrorMessage(error, "Could not decline invitation")
      })
  }
}
